import { NfcAuth as Base } from 'core/api/NfcAuth'
import { api, responseErrorCheck } from 'stylewhere/api'

export interface ValidateWithProductInfoResponse {
  verificationStatus: 'OK' | 'KO'
  statusCode: string
  verificationCode?: string
  verificationData?: {
    uid: string
    cxid?: string
    epc?: string
    additionalInformation?: {
      printerCode?: string
      sku?: string
      longSKU?: string
      description?: string
      pairingDate?: string
      pairingSupplier?: string
      madeIn?: string
      citesFlag?: string
      batchNumber?: string
      status?: string
      chrono?: string
      blockchainID?: string
      logisticStatus?: string
      serialNumber?: string
      returnCode?: string
      supplierCode?: string
      UCV?: string
      limitedEditionNumber?: string
    }
  }
}

export class NfcAuth extends Base {
  static validateWithProductInfo(apdu: string, uid: string, connectionId: string, apiBaseUrl?: string) {
    return api
      .get<any>(`${this.resolveApiBaseUrl(apiBaseUrl)}/mutualAuth/product-informations`, {
        apduRequest: apdu,
        connectionId,
        uid
      })
      .then((res) => responseErrorCheck(res))
  }

  static fetchCitesCertificate(serial: string, apiBaseUrl?: string) {
    return api
      .get<any>(
        `${this.resolveApiBaseUrl(apiBaseUrl)}/mutualAuth/cites-certificate`,
        { serial },
        { responseType: 'blob' }
      )
      .then((res) => responseErrorCheck(res))
  }
}
